import { c as _c } from "react/compiler-runtime";
import { useTheme } from "@opensea/next-themes";
import { Chip } from "@opensea/ui-kit";
import { useMemo } from "react";
export function AccountSwitcherChip(t0) {
  const $ = _c(4);
  const {
    children,
    className
  } = t0;
  const {
    resolvedTheme: theme
  } = useTheme();
  let t1;
  bb0: {
    switch (theme) {
      case "light":
        {
          t1 = "default";
          break bb0;
        }
      case "dark":
        {
          t1 = "frosted";
          break bb0;
        }
    }
    t1 = undefined;
  }
  const variant = t1;
  let t2;
  if ($[0] !== children || $[1] !== className || $[2] !== variant) {
    t2 = <Chip className={className} variant={variant}>{children}</Chip>;
    $[0] = children;
    $[1] = className;
    $[2] = variant;
    $[3] = t2;
  } else {
    t2 = $[3];
  }
  return t2;
}